import { memo, useEffect, useState } from "react"
import { Button, Grid, Paper, Typography } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete'

import FieldList      from "../../../../components/UserParameters/FieldList"
import InputParameter from "../../../../components/UserParameters/InputParameter"

const LEVELS = [
	{ key: 'lowRiskParameter', label: 'Baixo', color: 'success.main' },
	{ key: 'medRiskParameter', label: 'Médio', color: 'warning.main' },
	{ key: 'higRiskParameter', label: 'Alto',  color: 'error.main'   },
]

const RiskClauseCard = memo(({ value, index, highlightErrors, onChange, onDelete }) => {
	const [params, setParams] = useState({})
	const hasErrors = highlightErrors && value?.isValid === false

	useEffect(() => { setParams(value ?? {}) }, [value])

	const handleFieldChange = (field) => {
		const next = { ...params, field }
		setParams(next)
		onChange(next, index)
	}

	const handleLevelChange = (levelKey, operator, parameter) => {
		const next = { ...params, [levelKey]: { operator, parameter } }
		setParams(next)
		onChange(next, index)
	}

	return (
		<Paper variant="outlined" sx={{ p: 1 }}>
			<Grid container spacing={0.5} alignItems="flex-end">

				<Grid item xs={12} md>
					<Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
						Critério
					</Typography>
					<FieldList
						error={hasErrors}
						value={params.field}
						onChange={handleFieldChange}
						size="small"
						variant="numeric"
					/>
				</Grid>

				{params.field && LEVELS.map(({ key, label, color }) => (
					<Grid item xs={12} sm={4} md="auto" key={key} sx={{ minWidth: { md: 140 } }}>
						<Typography variant="caption" fontWeight="bold" color={color} sx={{ display: 'block', mb: 0.5 }}>
							Risco {label}
						</Typography>
						<InputParameter
							field={params.field}
							value={params[key]}
							error={hasErrors}
							size="small"
							onChange={(op, param) => handleLevelChange(key, op, param)}
						/>
					</Grid>
				))}

				<Grid item xs={12} md="auto" sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
					<Button
						variant="contained"
						color="error"
						size="large"
						onClick={() => onDelete(index)}
						sx={{ minWidth: 0, px: 1 }}
					>
						<DeleteIcon />
					</Button>
				</Grid>

			</Grid>

			{hasErrors && (
				<Typography variant="caption" color="error" sx={{ display: 'block', mt: 0.5 }}>
					Preencha todos os campos de risco.
				</Typography>
			)}
		</Paper>
	)
})

export default RiskClauseCard
